import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, WhyUs, Team, Process, Categories, DownloadApp, Banner, FeaturedCars, Offers, Gallery, FAQs, Partners, Booking } from '../../sections';


const HomePage = () => {

  return (
    <div className='homepage'>
      <Home />
      <Booking />
      <About />
      <Gallery />
      <Services />
      <WhyUs />
      <Categories />
      <Counter />
      <Process />
      <FeaturedCars />
      <Offers />
      <DownloadApp />
      <FAQs />
      <Testimonials />
      <Team />
      <Banner />
      <Blogs />
      <Partners />

    </div>
  )

}

export default HomePage;